/**
 * Shared full-screen loading state for simulation modules.
 *
 * Mirrors the card-centered loading layout the Reading, Listening, and
 * Writing interfaces use today. Parent controls the message so
 * per-module copy is preserved.
 */

import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import { Card } from "@/components/ui/card";

export interface SimulationModuleLoadingProps {
  /** Loading message; defaults to a generic i18n string. */
  readonly message?: string;
}

export function SimulationModuleLoading({
  message,
}: SimulationModuleLoadingProps) {
  const { t } = useTranslation();
  const text = message ?? t("common.loading", { defaultValue: "Loading..." });
  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-background">
      <Card className="p-8">
        <div className="flex flex-col items-center gap-4 text-center">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="font-ui text-muted-foreground">{text}</p>
        </div>
      </Card>
    </div>
  );
}
